import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: 'Il materiale \u00e8 digitale o fisico?',
    a: 'Il Mega-Pack \u00e8 completamente digitale. Potrai scaricarlo subito dopo l\u2019acquisto e utilizzarlo su computer, tablet o smartphone, oppure stamparlo.'
  }, {
    q: 'Come ricevo il materiale?',
    a: 'Subito dopo l\u2019acquisto riceverai un\u2019email con l\u2019accesso immediato per scaricare tutti i libri e i bonus inclusi nell\u2019offerta.'
  }, {
    q: 'Per quanto tempo avr\u00f2 accesso?',
    a: 'L\u2019accesso \u00e8 permanente. Paghi una sola volta e potrai utilizzare il materiale per sempre, quando vuoi.'
  }, {
    q: '\u00c8 adatto per tutte le fasce d\u2019et\u00e0?',
    a: 'S\u00ec, le attivit\u00e0 e i percorsi sono strutturati in modo da poter essere facilmente adattati a diversi livelli scolastici, dalla scuola dell\u2019infanzia fino alle medie.'
  }, {
    q: 'I pagamenti sono sicuri?',
    a: 'Assolutamente s\u00ec. Utilizziamo piattaforme di pagamento crittografate e sicure al 100%. I tuoi dati sono completamente protetti.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-gray-50" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-63">
          Domande Frequenti
        </h2>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-65">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-66">
                <span className="font-bold text-gray-900" data-id="element-67">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ml-2 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>
              <AnimatePresence data-id="element-69">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-70">
                    <div className="px-6 pb-4 text-gray-600" data-id="element-71">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}